import _ from "lodash"
import defaultMessages from "../../i18n/default.messages"

let messages = {
    'messages': {
        'es-MX': {
            'headerSearch': 'Buscar',
            tblTitle: "Lista de opciones del menú {menuName}",
            tblTitle2: "Lista de recursos",
            tblbutton: "Opción en menú",
            tblbutton2: "Agregar recurso",
            lblEdit: "Editar",
            lblDelete: "Eliminar",
            lblResource: "Asignar contenido",
            mdlCancel: "Cancelar",
            mdlSave: "Aceptar",

            header1Name: "Nombre",
            header1Jerarquia: "Sub Elementos",
            header1Posicion: "Posición",
            header1Type: "Recurso",
            header1Resource: "Contenido",
            header1Activo: "Activo",
            headerAction: "Acciones",


            lblNombre: "Nombre del menú",
            lbloptions: "Padre",
            lblPosition: "Posición",
            lblContent: "Tipo de contenido",
            lblResources: "Recurso",

            header2Resorce: "Recurso",
            header2type: "Tipo Recurso",
            lblValidation2: "Debes ingresar un nombre al menú",
            lblValidation3: "Debes de ingresar alguna posición al menú"


        },
        'en': {
            'headerSearch': 'Search',
            tblTitle: "List of menu options",
            tblTitle2: "Lista de recursos",
            tblbutton: "Option in menu",
            tblbutton2: "Add resource",
            lblEdit: "Edit",
            lblDelete: "Delete",
            lblResource: "Assign content",
            mdlCancel: "Cancel",
            mdlSave: "Accept",

            header1Name: "Name",
            header1Jerarquia: "Sub-elements",
            header1Posicion: "Position",
            header1Type: "Resource",
            header1Resource: "Content",
            header1Activo: "Active",
            headerAction: "Actions",


            lblNombre: "Menu name ",
            lbloptions: "Father",
            lblPosition: "Position",
            lblContent: "Type of content",
            lblResources: "Resource",

            header2Resorce: "Resource",
            header2type: "Resource Type",
            lblValidation2: "You must enter a name in the menu",
            lblValidation3: "You must enter a position in the menu"
        }
    }
}

export default _.merge(messages, defaultMessages)